import { providerName } from '@sweetauth/core'

import { API_URL } from '@/constants/env'

/**
 * Build-time auth config, derived from the active @sweetauth provider plus the env-aware
 * API origin. Centralizes the two things that differ between auth providers so callers
 * (next.config page-inclusion, the _app login bounce, login links) read one source.
 */

/**
 * Whether this build ships the app's own /auth/* pages — PropelAuth's hosted-flow login,
 * signup, and MFA UI. Keycloak hosts all of that itself and server_v2 owns the redirect,
 * so those pages don't apply to a keycloak build.
 */
export const HAS_IN_APP_AUTH_PAGES = providerName === 'propelauth_cloud'

/**
 * Where the login flow starts:
 *  - propelauth → the in-app `/auth/login` page (relative).
 *  - keycloak   → the server_v2 BFF `/auth/login` (absolute, env-aware via API_URL),
 *                 which starts the Keycloak OIDC redirect.
 */
export const LOGIN_URL = HAS_IN_APP_AUTH_PAGES
  ? '/auth/login'
  : `${API_URL}/auth/login`
